import { ROUTES } from "@/shared/constants/routes";
import { RouteObject } from "react-router-dom";
import GapAssessmentsPage from "../index";

export const ComplianceRoutes: RouteObject[] = [
  {
    path: ROUTES.COMPLIANCE_GAP_ASSESSMENTS,
    Component: GapAssessmentsPage,
  },
];
